import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';

import type { Router } from 'vue-router';
import { getCookie } from '@/api/user';

const router: Router = createRouter({
  routes,
  history: createWebHistory(),
  scrollBehavior() {
    return { top: 0 };
  },
});

// 路由守卫：未登录时跳转到登录页
router.beforeEach((to, _from, next) => {
  // 白名单：登录页和注册页不需要登录即可访问
  const whiteList = ['/login', '/register'];

  // 检查是否已登录（检查cookie）
  const isLogin = getCookie('token');

  if (whiteList.includes(to.path)) {
    // 在白名单中，直接放行
    next();
  } else {
    // 不在白名单中，需要检查登录状态
    if (isLogin) {
      // 已登录，放行
      next();
    } else {
      // 未登录，跳转到登录页
      next('/login');
    }
  }
});

export default router;